import React from "react";
import { Link, NavLink } from "react-router-dom";
import { unlistNFT, buyNFT } from "../../utilis/web3";

function SingleProductFixed(props) {
  const handleUnlistNFT = async () => {
    const unlisted = await unlistNFT(props.address, props.tokenId);
    if (!unlisted) {
      props.changeFixedListing(props.tokenId);
    }
  };

  const handleBuyNFT = async () => {
    const buy = await buyNFT(props.address, props.tokenId, props.productPrice);
    if (buy) {
      props.changeFixedListing(props.tokenId);
    }
  };

  return (
    <div className={props.classList}>
      <img
        src={props.imgSrc}
        alt={props.name}
        style={{
          width: "200px",
          height: "200px",
          position: "relative",
          bottom: "20px",
        }}
      />

      {/* Product Content  */}
      <div
        className="product-content "
        style={{
          textAlign: "center",
        }}
      >
        <div className="product-top">
          <h5>{props.name}</h5>
          <div className="d-flex justify-content-between">
            <h6>Price: {props.productPrice} ETH</h6>

            <div className="countdown-wrap">
              <ul className="countdown">
                <li>
                  <span className="hours">
                    {props.seller.slice(0, 4)}...{props.seller.slice(-4)}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="product-bottom">
          {/* Button Group  */}
          <div className="button-group">
            {/* <NavLink className="btn-circle love-react mr-10"></NavLink>

                     <div className="dropdown mr-10">
                        <button className="btn-circle btn-border dropdown-toggle"
                            data-bs-toggle="dropdown">
                            <img src="/img/icons/share.svg" alt="" className="svg" />
                        </button>
                        <ul className="dropdown-menu">
                            <li><NavLink className="dropdown-item"
                                to="https://www.facebook.com/"><img
                                    src="/img/icons/facebook.svg" alt="" /> Share on
                                Facebook</NavLink></li>
                            <li><NavLink className="dropdown-item"
                                to="https://www.twitter.com/"><img
                                    src="/img/icons/twitter.svg" alt="" /> Share on
                                Twitter</NavLink></li>
                            <li><NavLink className="dropdown-item"
                                to="https://www.Instagram.com/"><img
                                    src="/img/icons/instagram.svg" alt="" /> Share
                                on Instagram</NavLink></li>
                            <li><NavLink className="dropdown-item"
                                to="https://www.linkedin.com/"><img
                                    src="/img/icons/linkedin.svg" alt="" /> Share on
                                Linkedin</NavLink></li>
                        </ul>
                    </div> */}
            {props.address === props.seller ? (
              <button
                className="btn btn-sm btn-border ms-auto"
                onClick={handleUnlistNFT}
              >
                <img src="/img/icons/judge-icon.svg" alt="" className="svg" />
                Unlist
              </button>
            ) : (
              <button
                className="btn btn-sm btn-border ms-auto"
                onClick={handleBuyNFT}
              >
                <img src="/img/icons/judge-icon.svg" alt="" className="svg" />
                Buy
              </button>
            )}
          </div>
          {/* End Button Group  */}
        </div>
      </div>
      {/* End Product Content  */}
    </div>
  );
}

export default SingleProductFixed;
